import { styled } from '@mui/material';
import { up } from '../../../../theme';

export const classes = {
  root: 'root',
  MainBox: 'MainBox',
  ActionIcons: 'ActionIcons',
  paymentAgGridStyle: 'paymentAgGridStyle',
  downloadIcon: 'downloadIcon',
  cardComponent: 'cardComponent',
  cardHeader: 'cardHeader',
  closeAction: 'closeAction',
  loaderBox: 'loaderBox',
  cardCreditContent: 'cardCreditContent',
  inputHeading: 'inputHeading',
  formHelperText: 'formHelperText',
  textField: 'textField',
  addUserBtn: 'addUserBtn',
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.MainBox}`]: {
    height: `calc(100vh - ${theme.spacing(6)})`,
    [up('xs')]: {
      padding: '20px 14px',
    },
    [up('sm')]: {
      padding: '20px 16px',
    },
    [up('md')]: {
      padding: '23px 18px',
    },
    [up('lg')]: {
      padding: '25px 20px',
    },
    [up('xl')]: {
      padding: '30px 23px',
    },
    [up('xxl')]: {
      padding: '35px 25px',
    },
  },
  [`& .${classes.downloadIcon}`]: {
    color: theme.palette.primary.main,
    [up('xs')]: {
      marginTop: '3vh',
    },
    [up('sm')]: {
      marginTop: '3vh',
    },
    [up('md')]: {
      marginTop: '2vh',
    },
    [up('lg')]: {
      marginTop: '3vh',
    },
    [up('xl')]: {
      marginTop: '2vh',
    },
    [up('xxl')]: {
      marginTop: '1vh',
    },
  },
  [`& .${classes.cardComponent}`]: {
    borderRadius: '5px',
    [up('xs')]: {
      width: '330px',
      // height: '310px',
    },
    [up('sm')]: {
      width: '450px',
      // height: '370px',
    },
    [up('md')]: {
      width: '490px',
      // height: '410px',
    },
    [up('lg')]: {
      width: '540px',
      // height: '450px',
    },
    [up('xl')]: {
      width: '620px',
      // height: '500px',
    },
    [up('xxl')]: {
      width: '690px',
      // height: '560px',
    },
  },
  [`& .${classes.cardHeader}`]: {
    background: theme.palette.lunarBase.main,
    borderBottom: `1px solid ${theme.palette.lunarBase.lightest}`,
  },
  [`& .${classes.closeAction}`]: {
    cursor: 'pointer',
    [up('xs')]: {
      width: '16px',
      height: '16px',
    },
    [up('sm')]: {
      width: '18px',
      height: '18px',
    },
    [up('md')]: {
      width: '20px',
      height: '20px',
    },
    [up('lg')]: {
      width: '22px',
      height: '22px',
    },
    [up('xl')]: {
      width: '23px',
      height: '23px',
    },
    [up('xxl')]: {
      width: '24px',
      height: '24px',
    },
  },
  [`& .${classes.loaderBox}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  [`& .${classes.formHelperText}`]: {
    // marginLeft: theme.spacing(1.5),
    color: '#d32f2f',
  },
  [`& .${classes.cardCreditContent}`]: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '10px',
    [up('xs')]: {
      margin: '4px 0px 0px',
    },
    [up('sm')]: {
      margin: '4px 2px 0px',
    },
    [up('md')]: {
      margin: '5px 2px 0px',
    },
    [up('lg')]: {
      margin: '10px 5px 0px',
    },
    [up('xl')]: {
      margin: '13px 8px 0px',
    },
    [up('xxl')]: {
      margin: '18px 11px 0px',
    },
  },
  [`& .${classes.inputHeading}`]: {
    fontWeight: 500,
    paddingBottom: theme.spacing(0.1),
  },
  [`& .${classes.textField}`]: {
    marginBottom: '10px',
    '& .MuiFormHelperText-root': {
      marginLeft: '0px',
    },
    '& .MuiInputBase-input': {
      [up('xs')]: {
        height: '6px',
      },
      [up('sm')]: {
        height: '13px',
      },
      [up('md')]: {
        height: '13px',
      },
      [up('lg')]: {
        height: '17px',
      },
      [up('xl')]: {
        height: '25px',
      },
      [up('xxl')]: {
        height: '34px',
      },
    },
  },
  [`& .${classes.addUserBtn}`]: {
    ':hover': {
      background: theme.palette.primary.main,
      color: theme.palette.secondaryWhite.main,
    },
    [up('xs')]: {
      width: '70px',
      height: '25px',
      marginTop: '29px',
    },
    [up('sm')]: {
      width: '74px',
      height: '24px',
      marginTop: '30px',
    },
    [up('md')]: {
      width: '92px',
      height: '26px',
      marginTop: '30px',
    },
    [up('lg')]: {
      width: '105px',
      height: '35px',
      marginTop: '35px',
    },
    [up('xl')]: {
      width: '115px',
      height: '40px',
      marginTop: '40px',
    },
    [up('xxl')]: {
      width: '133px',
      height: '52px',
      marginTop: '45px',
    },
  },
  [`& .${classes.paymentAgGridStyle}`]: {
    [up('xs')]: {
      height: '60vh',
    },
    [up('sm')]: {
      height: '70vh',
    },
    [up('md')]: {
      height: '70vh',
    },
    [up('lg')]: {
      height: '72vh',
    },
    [up('xl')]: {
      height: '79vh',
    },
    [up('xxl')]: {
      height: '81vh',
    },
  },
  [`& .${classes.ActionIcons}`]: {
    marginRight: '2vw',
    marginTop: '9px',
    cursor: 'pointer',
    [up('xs')]: {
      width: '12',
      height: '12px',
    },
    [up('sm')]: {
      width: '14',
      height: '14px',
    },
    [up('md')]: {
      width: '16',
      height: '16px',
    },
    [up('lg')]: {
      width: '18',
      height: '18px',
    },
    [up('xl')]: {
      width: '20',
      height: '20px',
    },
    [up('xxl')]: {
      width: '22',
      height: '22px',
    },
  },
}));
